import { render, staticRenderFns } from "./SignEnterPage.vue?vue&type=template&id=a04b421c&scoped=true"
import script from "./SignEnterPage.vue?vue&type=script&lang=js"
export * from "./SignEnterPage.vue?vue&type=script&lang=js"
import style0 from "./SignEnterPage.vue?vue&type=style&index=0&id=a04b421c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04b421c",
  null
  
)

export default component.exports